/**
 * Auth0 profile photos arrive as 480px Gravatar URLs (`?s=480`); avatars render at 14–28
 * CSS px, so a page full of them fetches ~50× the pixels it shows. 128px covers the largest
 * slot at 2× DPR. Only the `s` param changes — the `d=` fallback redirect is untouched.
 */
const GRAVATAR_MAX_SIZE = 128;

const isGravatarUrl = (url: URL): boolean => url.hostname === 'gravatar.com' || url.hostname.endsWith('.gravatar.com');

/**
 * Avatar `src` must be a real URL or `undefined`. Seeded/legacy accounts can carry `''` or `null`
 * photo URLs; an empty-string `src` triggers React's empty-src error and makes browsers request
 * the current document as an image (CUR-592).
 */
export const normalizeAvatarSrc = (src: string | null | undefined): string | undefined => {
    if (!src) {
        return undefined;
    }
    try {
        const url = new URL(src);
        const requestedSize = Number(url.searchParams.get('s'));
        if (isGravatarUrl(url) && Number.isFinite(requestedSize) && requestedSize > GRAVATAR_MAX_SIZE) {
            url.searchParams.set('s', String(GRAVATAR_MAX_SIZE));
            return url.toString();
        }
    } catch {
        // Relative or malformed URLs pass through unchanged.
    }
    return src;
};
